import template from './stock.html';
import modal from './modal.html';
import './stock.scss';

let component = {
	bindings: {
		product: '='
	},
	template: template,
	controller: function(
		Product,
		$scope,
		$ionicModal
	) {
		"ngInject"

		var vm = this;
		
		vm.statusLoader = false;

		var calc = function() {
			if (vm.product.webshop) {
				vm.webshop = 'green';
			} else {
				vm.webshop = 'grey';
			}
			if (vm.product.store) {
				if (vm.product.store.stock >= 5) {
					vm.store = 'green';
				} else if(vm.product.store.stock < 5 && vm.product.store.stock > 1) {
					vm.store = 'orange';
				} else {
					vm.store = 'red';
				}
			} else {
				vm.store = 'grey';
			}
		}

		vm.getStatus = function() {
			vm.statusLoader = true;
			Product.status(vm.product.id).then(res => {
				if (res.price) {
					vm.product.store.stock = res.stock;
					vm.product.store.price = res.price;
					vm.product.price = res.price;	
				}
			}).finally(() => {
				calc();
				vm.statusLoader = false;
				$scope.modal = $ionicModal.fromTemplate(modal, {
					scope: $scope,
					animation: 'slide-in-up'
				});
				$scope.modal.show();
			});
		}

		vm.close = function() {
			$scope.modal.remove();
		}

		calc();
		
	}
};

export default component;



// WEBPACK FOOTER //
// ./app/components/stock/stock.component.js